export class News {
	applyEvents()
	{
		let _this = this;

		if ($('input[name=mlt_villages_all]').length)
		{
			if ($('input[name=mlt_villages_all]').prop('checked'))
			{
				this.disableVillages();
			}
			else
			{
				this.enableVillages();
			}

			$('input[name=mlt_villages_all]').on('change', function(){
				if ($(this).prop('checked'))
				{
					_this.disableVillages();
				}
				else
				{
					_this.enableVillages();
				}
			});

			$('input[name="mlt_villages[]"]').on('change', function(){
				_this.checkVillages();
			})
		}
	}

	disableVillages()
	{
		$('input[name="mlt_villages[]"]').closest('.form-item__main').find('input').prop('disabled', true);
	}

	enableVillages()
	{
		$('input[name="mlt_villages[]"]').closest('.form-item__main').find('input').prop('disabled', false);
		this.checkVillages();
	}

	checkVillages()
	{
		if ($('input[name="mlt_villages[]"]:checked').length)
		{
			$('input[name="mlt_villages[]"]').closest('.form-item__main').find('.form-multi__top-input')[0].setCustomValidity('');
		}
		else
		{
			$('input[name="mlt_villages[]"]').closest('.form-item__main').find('.form-multi__top-input')[0].setCustomValidity('Выберите посёлок');
		}
	}
}